import { formatDateTime } from '@/common/utils/formatters'
import { contractEnvelopeSignableTypeStrategy } from '@/features/privateCompanyLeadsFunnel/constants/contractEnvelopeSignableType.constant'
import { ContractEnvelopeData } from '@/features/privateCompanyLeadsFunnel/types/privateCompanyLeadContractEnvelope'

export class PrivateCompanyLeadContractEnvelopeTransformer {
  static tableTransformer: (contractEnvelope?: ContractEnvelopeData) => any = (contractEnvelope) => {
    const contractEnvelopeUsers = [
      {
        ...contractEnvelope?.contractee,
        signable_type: 'contractee',
      },
      {
        ...contractEnvelope?.contractor,
        signable_type: 'contractor',
      },
    ]

    if (contractEnvelope?.surety) {
      contractEnvelopeUsers.push({
        ...contractEnvelope.surety,
        signable_type: 'surety',
      })
    }

    contractEnvelope?.witnesses?.forEach((witness) => {
      contractEnvelopeUsers.push({
        ...witness,
        signable_type: 'witness',
      })
    })

    return contractEnvelopeUsers.map((contractEnvelopeUser) => ({
      signable_type:
        contractEnvelopeSignableTypeStrategy[
          contractEnvelopeUser.signable_type as keyof typeof contractEnvelopeSignableTypeStrategy
        ] || '',
      full_name: contractEnvelopeUser.full_name,
      signed_at: contractEnvelopeUser.signed_at ? formatDateTime(new Date(contractEnvelopeUser.signed_at)) : '',
    }))
  }
}
